import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NavigationEnd, Router } from '@angular/router';
import {
  NgxFileDropEntry,
  FileSystemFileEntry,
  FileSystemDirectoryEntry,
} from 'ngx-file-drop';
import { NgxSpinnerService } from 'ngx-spinner';
import { fromEvent } from 'rxjs';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import {
  Lector,
  mensajesArrayExcel,
  RequestProductsAdd,
  ResponseProductsInformacion,
  ResponseSearchProducts,
  ResponseUSer,
} from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { CodeBarScannerComponent } from '../modal/code-bar-scanner/code-bar-scanner.component';
import * as XLSX from 'xlsx';
import { AddRateProductComponent } from '../modal/add-rate-product/add-rate-product.component';
import { ReportProductReceiveridComponent } from '../modal/report-product-receiverid/report-product-receiverid.component';
@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css'],
})
export class ProductsComponent implements OnInit, AfterViewInit, OnDestroy {
  isActive='1';
	viewRegistrosMasivos=false;
  datosArrayExcel: mensajesArrayExcel;
  arrayMensajesMasivoExcel: mensajesArrayExcel[];
  productosMensajes = [];
  valorCustomerMasivo = '';
  ViewTableProducts = false;
  mySubscription: any;
  currentUser: ResponseUSer;
  activo = true;
  Toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    background: ' #ffffff29',

    padding: '80px 20px 80px',

    didOpen: (toast) => {
      Swal.showLoading();
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });
  ButtonCancel = false;
  tabSearch = false;
  tabCreate = false;
  tabImport = true;
  tabUpdate = true;
  ProductEdit = 0;
  DatosProductsAdd: RequestProductsAdd;
  formProducts: FormGroup;
  tabs = new FormControl(0);
  arrayDataInformacionProducts: ResponseProductsInformacion[];
  Customer = [];
  typeUnit = [];
  selected = 'option2';

  selected4 = 'option2';

  displayedColumns: string[] = [
    'Id',
    'ItemNumber',
    'ItemDescription',
    'MasterBarcode',
    'PalletAmount',
    'Active',
  ];
  dataSource: MatTableDataSource<ResponseSearchProducts>;
  datosLector: Lector;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private router: Router,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((events) => {
        this.authenticationService.currentUser.subscribe(
          (x) => (this.currentUser = x)
        );
      });
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log('ddddd');
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = true;
      }
    });
    // Create 100 users

    // Assign the data to the data source for the table to render
    this.dataSource = new MatTableDataSource();
    this.Customer = [];
    this.typeUnit = [];
    this.ProductEdit = 0;
    this.productosMensajes = [];
	this.arrayMensajesMasivoExcel=[];
  }

  ngOnInit(): void {
    this.formProducts = this.formBuilder.group({
      CustomerSelect: ['', Validators.required],
      skuItemNumber: ['', Validators.required],
      description: ['', Validators.required],
      additionalDescription: [''],
      selectUnitType: ['', Validators.required],
      boxBarcode: [''],
      innerBoxBarcode: [''],
      productBarcode: [''],
      length: [''],
      width: [''],
      Height: [''],
      Weight: [''],
      MasterBox: [''],
      InnerBox: [''],
      ProductName: [''],
      PalletQuantity: [''],
      ReorderQuantity: [''],
      SerialNumber: [''],
      MiscField: [''],
      checked: [''],
      StackablePallet: [''],
    });
    this.productsGet.checked.setValue(true);
    this.formProducts.controls.skuItemNumber.setValue('SKU-');
  }
  ngAfterViewInit() {
    this.OnSelectCostumer();
    this.OnSelectTypeUnit();
    const main = <HTMLInputElement>document.getElementById('SubMenu');

    fromEvent(main, 'mouseenter')
      .pipe(
        switchMap((event) => {
          console.log('show');
          main.style.display = 'block';
          return fromEvent(main, 'mouseleave').pipe(debounceTime(500));
        })
      )
      .subscribe((val) => {
        console.log('hide');
        main.style.display = 'none';
      });

    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.productsGet.checked.setValue(true);
    this.OnCancel();
  }
  ngOnDestroy(): void {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
    try {
      localStorage.setItem('header', '0');
      var element = document.getElementById('SubMenu');
      element.style.display = 'none';
    } catch (error) {}
  }

  // convenience getter for easy access to form fields
  get productsGet() {
    return this.formProducts.controls;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  public files: NgxFileDropEntry[] = [];

  public dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          // Here you can access the real file
          console.log(droppedFile.relativePath, file);

          /**
          // You could upload it like this:
          const formData = new FormData()
          formData.append('logo', file, relativePath)
 
          // Headers
          const headers = new HttpHeaders({
            'security-token': 'mytoken'
          })
 
          this.http.post('https://mybackend.com/api/upload/sanitize-and-save-logo', formData, { headers: headers, responseType: 'blob' })
          .subscribe(data => {
            // Sanitized logo returned from backend
          })
          **/
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        console.log(droppedFile.relativePath, fileEntry);
      }
    }
  }

  public fileOver(event) {
    console.log(event);
  }

  public fileLeave(event) {
    console.log(event);
  }

  public files2: NgxFileDropEntry[] = [];

  public dropped2(files: NgxFileDropEntry[]) {
    this.files2 = files;
    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          // Here you can access the real file
          console.log(droppedFile.relativePath, file);
          let workBook = null;
          let jsonData = null;
          var reader = new FileReader();

          reader.onload = (event) => {
            const data = reader.result;
            workBook = XLSX.read(data, { type: 'binary' });
            jsonData = workBook.SheetNames.reduce((initial, name) => {
              const sheet = workBook.Sheets[name];
              initial[name] = XLSX.utils.sheet_to_json(sheet);
              return initial;
            }, {});

            for (let index = 0; index < jsonData.Hoja1.length; index++) {
         

              this.DatosProductsAdd = {
                tipo: 0,
                tblCompanyID: Number(this.authenticationService.currentUserValue.companyIdWh),
                tblCustomerID: Number(this.valorCustomerMasivo),
                itemNumber: String(jsonData.Hoja1[index].itemNumber||''),
                itemDescription: String(jsonData.Hoja1[index].itemDescription||''),
                itemDescription1: String(
                  jsonData.Hoja1[index].itemDescription1||''
                ),
                masterBarcode: String(jsonData.Hoja1[index].masterBarcode || this.makeid(10)),
                boxBarcode: String(jsonData.Hoja1[index].boxBarcode || this.makeid(10)),
                itemBarcode: String(jsonData.Hoja1[index].itemBarcode || this.makeid(10)),
                boxDimsHeight: String(jsonData.Hoja1[index].boxDimsHeight || 1),
                boxDimsWidth: String(jsonData.Hoja1[index].boxDimsWidth || 1),
                boxDimsLength: String(jsonData.Hoja1[index].boxDimsLength || 1),
                boxWeight: String(jsonData.Hoja1[index].boxWeight || 1),
                unitMeasureType: Number(
                  jsonData.Hoja1[index].unitMeasureType || 0
                ),
                numberInMaster: Number(
                  jsonData.Hoja1[index].numberInMaster || 1
                ),
                numberInInner: Number(jsonData.Hoja1[index].numberInInner || 1),
                minReorder: Number(jsonData.Hoja1[index].minReorder || 1),
                itemValue: String(jsonData.Hoja1[index].itemValue || 1),
                serialNo: String(jsonData.Hoja1[index].serialNo || 0),
                lotNumber: String(jsonData.Hoja1[index].lotNumber || 0),
                palletAmount: Number(jsonData.Hoja1[index].palletAmount || 1),
                active: Boolean(jsonData.Hoja1[index].active),
                warehouseStation: '',
                productImage: '',
                StackablePallet: String(
                  jsonData.Hoja1[index].StackablePallet || 0
                ),
              };




              this.http
                .post<any>(
                  `${environment.apiUrl}/Products/ProductsInsert`,
                  this.DatosProductsAdd,
                  {
                    headers: new HttpHeaders({
                      'Access-Control-Allow-Origin': '*',
                      'Access-Control-Allow-Headers': '*',
                      'Access-Control-Allow-Methods': '*',
                      Authorization: 'Bearer ' + this.authenticationService.currentUserValue.token,
                    }),
                  }
                )
                .subscribe((response: any) => {
                  try {
                    var res = String(response.responses);
                    this.datosArrayExcel = {
                      celda: String(index),
                      itemname: String(jsonData.Hoja1[index].itemNumber||''),
                      mensajes: res,
                    };

                    this.arrayMensajesMasivoExcel.push(this.datosArrayExcel);
                  } catch (error) {}
                }); 
            }

this.viewRegistrosMasivos=true;

          };

          reader.readAsBinaryString(file);
        });
      } else {
      }
    }
  }

  public fileOver2(event) {
    console.log(event);
  }

  public fileLeave2(event) {
    console.log(event);
  }

  OnSelectCostumer() {
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    var Request = {};
    Request['CompanyId'] = String(
      this.authenticationService.currentUserValue.companyIdWh
    );
    Request['Active'] = String('1');

    this.http
      .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderCustomer`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization:
            'Bearer ' + this.authenticationService.currentUserValue.token,
        }),
      })
      .subscribe((response: any) => {
        this.Customer = response;
      });
  }

  OnSelectSearchProducts(data: any) {
    this.ViewTableProducts = true;
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    var Request = {};
    Request['companyId'] = Number(json.companyIdWh);
    Request['customerId'] = Number(data);

    this.http
      .post<any>(`${environment.apiUrl}/Products/ProductsSearch`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token,
        }),
      })
      .subscribe((response: ResponseSearchProducts[]) => {
        this.dataSource = new MatTableDataSource(response);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      });
  }

  OnSelectSearchProductsNew() {
    this.spinner.show()
    this.ViewTableProducts = true;
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario


    this.http
      .get<any>(`${environment.apiUrl}/Products/searchProduct?companyId=${this.authenticationService.currentUserValue.companyIdWh}&customerId=${Number(this.selected)}&active=${Number(this.isActive)}`, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token,
        }),
      })
      .subscribe((response: ResponseSearchProducts[]) => {
        this.spinner.hide();
        this.dataSource = new MatTableDataSource(response);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      });
  }
  OnSelectTypeUnit() {
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    var Request = {};
    Request['companyId'] = json.companyIdWh;
    Request['active'] = '1';

    this.http
      .post<any>(`${environment.apiUrl}/Products/ProductsTypeUnit`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token,
        }),
      })
      .subscribe((response: any) => {
        this.typeUnit = response;
      });
  }

  OnEditProducts(data: ResponseSearchProducts) {
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    var Request = {};
    Request['companyId'] = Number(json.companyIdWh);
    Request['productId'] = Number(data.Id);

    this.http
      .post<any>(
        `${environment.apiUrl}/Products/ProductsInformacion`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token,
          }),
        }
      )
      .subscribe((response: ResponseProductsInformacion[]) => {
        this.arrayDataInformacionProducts = response;
        this.ProductEdit = response[0].Id;
        // this.CustomerSelect = response[0].tblCustomerID;
        this.formProducts.controls.CustomerSelect.setValue(
          Number(response[0].tblCustomerID)
        );
        this.formProducts.controls.CustomerSelect.disable();

        this.productsGet.skuItemNumber.setValue(response[0].ItemNumber);
        this.formProducts.controls.skuItemNumber.disable();
        this.productsGet.description.setValue(response[0].ItemDescription);
        this.productsGet.additionalDescription.setValue(
          response[0].ItemDescription1
        );
        this.productsGet.boxBarcode.setValue(response[0].BoxBarcode);
        this.productsGet.innerBoxBarcode.setValue(response[0].MasterBarcode);
        this.productsGet.productBarcode.setValue(response[0].ItemBarcode);

        this.productsGet.Height.setValue(response[0].BoxDimsHeight.toFixed(2));
        this.productsGet.width.setValue(response[0].BoxDimsWidth.toFixed(2));
        this.productsGet.length.setValue(response[0].BoxDimsLength.toFixed(2));
        this.productsGet.Weight.setValue(response[0].BoxWeight.toFixed(2));

        this.productsGet.selectUnitType.setValue(response[0].UnitMeasureType);

        this.productsGet.MasterBox.setValue(response[0].NumberInMaster);
        this.productsGet.InnerBox.setValue(response[0].NumberInInner);
        this.productsGet.ReorderQuantity.setValue(response[0].MinReorder);
        this.productsGet.ProductName.setValue(response[0].ItemValue);
        this.productsGet.SerialNumber.setValue(response[0].SerialNo);
        this.productsGet.MiscField.setValue(response[0].LotNumber);
        this.productsGet.PalletQuantity.setValue(response[0].PalletAmount);
        this.productsGet.checked.setValue(response[0].Active);
        this.productsGet.StackablePallet.setValue(response[0].StackablePallet);
        this.activo = response[0].Active;
        this.tabs = new FormControl(0);
        this.tabSearch = true;
        this.tabCreate = false;
        this.tabImport = true;
        this.tabUpdate = true;
        this.ButtonCancel = true;
      });
  }
  OnProductsAdd() {
    var label = '';
    // stop here if form is invalid
    if (this.formProducts.invalid) {
      if (this.formProducts.controls.CustomerSelect.value == '') {
        label += '<p>Select company name</p>';
      }
      if (this.formProducts.controls.skuItemNumber.value == '') {
        label += '<p>Item Number</p>';
      }
      if (this.formProducts.controls.description.value == '') {
        label += '<p>Descripcion</p>';
      }
      if (this.formProducts.controls.selectUnitType.value == '') {
        label += '<p>Select Unit type</p>';
      }

      Swal.fire({
        title: '<strong>Requiered</strong>',
        icon: 'info',
        html: label,
      });
      return;
    }
    this.OnChangeLoader();
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    this.DatosProductsAdd = {
      tipo: this.ProductEdit,
      tblCompanyID: Number(json.companyIdWh),
      tblCustomerID: Number(this.formProducts.controls.CustomerSelect.value),
      itemNumber: String(this.productsGet.skuItemNumber.value),
      itemDescription: String(this.productsGet.description.value),
      itemDescription1: String(
        this.productsGet.additionalDescription.value || ' '
      ),
      masterBarcode: String(this.productsGet.boxBarcode.value || 1),
      boxBarcode: String(this.productsGet.innerBoxBarcode.value || 1),
      itemBarcode: String(this.productsGet.productBarcode.value || 1),
      boxDimsHeight: String(this.productsGet.Height.value || 1),
      boxDimsWidth: String(this.productsGet.width.value || 1),
      boxDimsLength: String(this.productsGet.length.value || 1),
      boxWeight: String(this.productsGet.Weight.value || 1),
      unitMeasureType: Number(this.productsGet.selectUnitType.value || 1),
      numberInMaster: Number(this.productsGet.MasterBox.value || 1),
      numberInInner: Number(this.productsGet.InnerBox.value || 1),
      minReorder: Number(this.productsGet.ReorderQuantity.value || 1),
      itemValue: String(this.productsGet.ProductName.value || 1),
      serialNo: String(this.productsGet.SerialNumber.value || 0),
      lotNumber: String(this.productsGet.MiscField.value || 0),
      palletAmount: Number(this.productsGet.PalletQuantity.value || 1),
      active: this.productsGet.checked.value,
      warehouseStation: ' ',
      productImage: ' ',
      StackablePallet: String(this.productsGet.StackablePallet.value),
    };
    this.http
      .post<any>(
        `${environment.apiUrl}/Products/ProductsInsert`,
        this.DatosProductsAdd,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token,
          }),
        }
      )
      .subscribe((response: any) => {
        var res = String(response.responses);
        if (res.includes('success:')) {
          this.OnSelectSearchProducts(
            this.formProducts.controls.CustomerSelect.value
          );
          this.OnCancel();
        } else if (res.includes('success-update:')) {
          this.OnSelectSearchProducts(
            this.formProducts.controls.CustomerSelect.value
          );
          this.OnCancel();
        } else {
          this.Toast.fire({
            icon: 'error',
            text: res,
          });
        }
      });
  }
  makeid(length) {
    var result = '';
    var characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  OnCancel() {
    this.tabSearch = false;
    this.tabCreate = false;
    this.tabImport = true;
    this.tabUpdate = true;
    this.ProductEdit = 0;
    //this.CustomerSelect = 0;
    this.formProducts.controls.CustomerSelect.setValue(null);
    this.productsGet.skuItemNumber.setValue('SKU-');
    this.productsGet.description.setValue(null);
    this.productsGet.additionalDescription.setValue(null);
    this.productsGet.boxBarcode.setValue(String(this.makeid(10)));
    this.productsGet.innerBoxBarcode.setValue(String(this.makeid(10)));
    this.productsGet.productBarcode.setValue(String(this.makeid(10)));

    this.productsGet.Height.setValue('1.00');
    this.productsGet.width.setValue('1.00');
    this.productsGet.length.setValue('1.00');
    this.productsGet.Weight.setValue('1.00');

    this.productsGet.selectUnitType.setValue(1);

    this.productsGet.MasterBox.setValue('1');
    this.productsGet.InnerBox.setValue('1');
    this.productsGet.ReorderQuantity.setValue('1');
    this.productsGet.ProductName.setValue('1.00');
    this.productsGet.SerialNumber.setValue('1');
    this.productsGet.MiscField.setValue('1');
    this.productsGet.PalletQuantity.setValue('1');
    this.productsGet.StackablePallet.setValue('0');
    this.formProducts.controls.CustomerSelect.enable();
    this.formProducts.controls.skuItemNumber.enable();
    this.productsGet.checked.setValue(true);
    this.tabs = new FormControl(0);
    this.ButtonCancel = false;
  }
  OnCheck(data: boolean) {
    console.log(this.productsGet.checked.value);
    this.activo = this.productsGet.checked.value;
  }
  OnDelete(data: ResponseSearchProducts) {
    this.OnChangeLoader();
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    var Request = {};
    Request['companyId'] = Number(json.companyIdWh);
    Request['productsId'] = data.Id;
    Request['users'] = json.useremail;
    this.http
      .post<any>(`${environment.apiUrl}/Products/ProductsDelete`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token,
        }),
      })
      .subscribe((response: any) => {
        if (response.responses == 'success') {
          this.OnSelectSearchProducts(this.selected);
        } else {
          this.Toast.fire({
            icon: 'info',
            text: response.responses,
          });
        }
      });
  }
  openDialogLector(): void {
    const dialogRef = this.dialog.open(CodeBarScannerComponent, {
      width: '300px',
      data: this.datosLector,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.dataSource.filter = result.Resultado.trim().toLowerCase();

      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    });
  }
  OnChangeLoader() {
    this.spinner.show();

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 3000);
  }
  @ViewChild('exportExcel') table: ElementRef;
  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    ); //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'SheetJS.xlsx');
  }
  @ViewChild('Importexport') tableex: ElementRef;
  exportAsExcelImport() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.tableex.nativeElement
    ); //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'items');

    /* save to file */
    XLSX.writeFile(wb, 'Import.xlsx');
  }
  enter2tab(e) {
    if (e.keyCode == 13) {
       var cb = parseInt($(this).attr('tabindex'));
 
        if ($(':input[tabindex=\'' + (cb + 1) + '\']') != null) {
            $(':input[tabindex=\'' + (cb + 1) + '\']').focus();
            $(':input[tabindex=\'' + (cb + 1) + '\']').select();
            e.preventDefault();
 
            return false;
        }
    }
}

openDialogRateAmount(datos:any): void {
  const dialogRef = this.dialog.open(AddRateProductComponent, {
    width: '70vw',
    height:'80vh',
    data: datos,
  });

  dialogRef.afterClosed().subscribe((result) => {
    
  });
}
openDialogExportReceiverID(datos:any): void {
  console.log(datos)
  const dialogRef = this.dialog.open(ReportProductReceiveridComponent, {
    width: '40vw',
    height:'40vh',
    data: datos.Id,
  });

  dialogRef.afterClosed().subscribe((result) => {
    
  });
}
}
